import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatArchiveInfo } from '../../components/ChatArchiveInfo';
import { chatListSelector } from '../../selectors';
import { ERoute } from '../../types/route';

export const ChatArchiveInfoContainer = () => {
  const chatList = useSelector(chatListSelector);

  if (chatList.currentRoute !== ERoute.Archive) {
    return null;
  }

  return <ChatArchiveInfo />;
};
